"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.formEventHandlerCreator = formEventHandlerCreator;
var _actions = require("../../actions");
var _utils = require("../../utils");
function formEventHandlerCreator(getState, dispatch) {
  return ({
    target: inputElement,
    type: eventType
  }) => {
    const {
      inputStates
    } = getState();
    const registeredInput = (0, _utils.getFirstRegisteredInputByName)(inputStates, inputElement.name);
    if (!registeredInput) {
      return;
    }
    if (eventType === 'change' || eventType === 'input') {
      dispatch((0, _actions.checkIfWatched)(inputElement.name));
      dispatch((0, _actions.formModified)(true));
    }
    dispatch((0, _actions.checkShouldValidate)(registeredInput, eventType));
  };
}